import SubSystemType from 'SubSystemType';
import BaseServiceRequestIIS from 'BaseServiceRequestIIS';

class FindGetBlocksRequest extends BaseServiceRequestIIS {
    constructor() {
        super();
    }

    getServiceMethod() {
        return "FindGetBlocks2";
    }
    getSubSystem() {
        return SubSystemType.GRAPH;
    }

    getMessageName() {
        return 'FindGetBlocksReply2';
    }
}

export default FindGetBlocksRequest;